/**
 * Marks the element a whole-supplement mark borders: the supplement's own visual
 * card, whose box and border radius the mark takes over. A wrapper around the whole
 * type renderer can't stand in for it — its box trails the card by the card's own
 * margin, and paint inset into that wrapper hides behind the card's background.
 */
export const SUPPLEMENT_CARD_ATTRIBUTE = 'data-annotation-supplement-card';

export const SUPPLEMENT_CARD_PROPS = {[SUPPLEMENT_CARD_ATTRIBUTE]: ''} as const;

/**
 * On the wrapper: arms the card's 4px border (transparent until marked), so the box
 * is reserved once and neither hovering nor marking shifts layout.
 */
export const SUPPLEMENT_REGION_CLASS = 'annotation-supplement';

/** The border color, set on the wrapper and inherited by the card, which paints it. */
export const SUPPLEMENT_BORDER_VARIABLE = '--annotation-supplement-border';
